import removeAcentos from '@/utils/removeAcentos'


/* eslint-disable no-param-reassign */
let VueInputDirectives = {};

function createHandler({clean, config}) {
  return ({target, type, isTrusted}) => {
    if (type === 'paste') {
      target.value = '';
    }

    const start = target.selectionStart;
    const end = target.selectionEnd;

    if (target.value === '') return 

    let value = clean(target.value);
    target.value = value
    if (config.config === 'uppercase' && target.value) target.value = value.toUpperCase()
    target.dataset.value = target.value

    if (type === 'clearacc' || isTrusted) {
      target.setSelectionRange(start, end);
      target.dispatchEvent(new Event('input'))
    }
  }
}

export const getInputElement = (el, vnode) => {
  return vnode.tag === 'input' ? el : el.querySelector('input:not([readonly])');
};

export const replaceAcentos = function (text) {
  if (!text) return null
  text = removeAcentos(text)
  return text
}

export const getCleaner = clearValue => {
  if (typeof clearValue === 'function') {
    return clearValue;
  }
  return replaceAcentos;
};

VueInputDirectives.install = function (Vue, options) {

  Vue.directive('remove-acentos', {
    bind(el, binding, vnode) {
     
      var config = {config: ''}
      var context = binding.value
      if (Array.isArray(context) || typeof context === 'string') {
        config = {config: context}
      }

      const _input = function (el, {value}, vnode) {
        el = getInputElement(el, vnode);
        el.addEventListener('input', ({target}) => target.value, false);
        el.value = value;
      };

      const clean = getCleaner(_input.clearValue);
      const handler = createHandler({clean, config})

      el = getInputElement(el, vnode);

      el.addEventListener('input', handler, false);
      el.addEventListener('paste', handler, false);
      el.addEventListener('blur', handler, false);
      el.addEventListener('clearacc', handler, false);

      handler({target: el, type: 'clearacc'});

      
    },
    update(el, {}, vnode){
      el = getInputElement(el, vnode);
      Vue.nextTick(() => {
        const previousValue = el.dataset.value || ''
        if (previousValue !== el.value) {
          el.dispatchEvent(new Event('clearacc'));
        }
      });
    }
  }),

  Vue.directive('numeric-only', {
    bind(el, binding, vnode) {
      let handlerInput = (e) => {
        const hasNumberRgx = /^[0-9]*$/;
        const numberRgx = /[^0-9]/g;
        if (hasNumberRgx.test(e.target.value) === false) {
          const start = e.target.selectionStart;
          const end = e.target.selectionEnd;
          e.target.value = e.target.value.replace(numberRgx, '');
          e.target.setSelectionRange(start, end);
          e.target.dispatchEvent(new CustomEvent('input'))
        }
      };
      el.addEventListener('input', handlerInput);
    }
  })

  Vue.directive('alphabetic-only', {
    bind(el, binding, vnode) {
      let handlerInput = (e) => {
        const hasAlphabeticRgx = /^[A-Za-z]+$/;
        const alphabeticRgx = /[^a-zA-Z]+/g;
        if (hasAlphabeticRgx.test(e.target.value) === false) {
          const start = e.target.selectionStart;
          const end = e.target.selectionEnd;
          e.target.value = e.target.value.replace(alphabeticRgx, '');
          e.target.setSelectionRange(start, end);
          e.target.dispatchEvent(new CustomEvent('input'))
        }
      };
      el.addEventListener('input', handlerInput);
    }
  })

  Vue.directive('max-length', {
    bind: function(el, binding) {
      let max_chars = binding.expression;
      let handlerInput = (e) => {
        if (e.target.value.length > max_chars) {
          e.target.value = e.target.value.substr(0, max_chars);
          e.target.dispatchEvent(new CustomEvent('input'))
        }
      };
      el.addEventListener('input', handlerInput);
    }
  })

  Vue.directive('uppercase-only', {
    bind(el, binding, vnode) {
      let handlerInput = (e) => {
        const hasLowercaseRgx = /[a-z]/;
        if (hasLowercaseRgx.test(e.target.value) === true) {
          const start = e.target.selectionStart;
          const end = e.target.selectionEnd;
          e.target.value = e.target.value.toUpperCase()
          e.target.setSelectionRange(start, end);
          e.target.dispatchEvent(new CustomEvent('input'))
        }
      };
      el.addEventListener('input', handlerInput);
    }
  })

  Vue.directive('lowercase-only', {
    bind(el, binding, vnode) {
      let handlerInput = (e) => {
        const hasUppercaseRgx = /[A-Z]/;
        if (hasUppercaseRgx.test(e.target.value) === true) {
          const start = e.target.selectionStart;
          const end = e.target.selectionEnd;
          e.target.value = e.target.value.toLowerCase()
          e.target.setSelectionRange(start, end);
          e.target.dispatchEvent(new CustomEvent('input'))
        }
      };
      el.addEventListener('input', handlerInput);
    }
  })

}

/*
function removeAcentos( newStringComAcento ) {
  var string = newStringComAcento;
  if (!string) return string
  var mapaAcentosHex 	= {
    a : /[\xE0-\xE6]/g,
    A : /[\xC0-\xC6]/g,
    e : /[\xE8-\xEB]/g,
    E : /[\xC8-\xCB]/g,
    i : /[\xEC-\xEF]/g,
    I : /[\xCC-\xCF]/g,
    o : /[\xF2-\xF6]/g,
    O : /[\xD2-\xD6]/g,
    u : /[\xF9-\xFC]/g,
    U : /[\xD9-\xDC]/g,
    c : /\xE7/g,
    C : /\xC7/g,
    n : /\xF1/g,
    N : /\xD1/g,
  };

  for ( var letra in mapaAcentosHex ) {
    var expressaoRegular = mapaAcentosHex[letra];
    string = string.replace( expressaoRegular, letra );
  }

  return string;
}
*/

function event (name) {
  var evt = document.createEvent('Event')
  evt.initEvent(name, true, true)
  return evt
}

export default VueInputDirectives;


// WEBPACK FOOTER //
// ./src/directives/index.js